import React, { useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../config";

const CreateClinicManager: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    clinicCode: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setError("Please enter a valid email.");
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setError(null);
    setMessage(null);

    try {
      const response = await axios.post(
        `${SERVER_URL}/api/auth/clinic-manager/signup`,
        {
          ...formData,
          passwordHash: formData.password, // expected by backend
        }
      );

      if (response.status === 201) {
        setMessage("Clinic Manager registered successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          clinicCode: "",
        });
      }
    } catch (err: any) {
      console.error("Signup error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "Signup failed.");
    }
  };

  return (
    <div className="clinic-container">
      <h2>Create Clinic Manager</h2>
      {message && (
        <p className="message" style={{ color: "green" }}>
          {message}
        </p>
      )}
      {error && (
        <p className="message" style={{ color: "red" }}>
          {error}
        </p>
      )}
      <form onSubmit={handleSubmit} className="clinic-form">
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password (min 6 chars)"
          value={formData.password}
          onChange={handleChange}
          required
          minLength={6}
        />
        <input
          type="text"
          name="clinicCode"
          placeholder="Clinic Code"
          value={formData.clinicCode}
          onChange={handleChange}
          required
        />
        <button type="submit">Register Clinic Manager</button>
      </form>
    </div>
  );
};

export default CreateClinicManager;
